import { render, staticRenderFns } from "./VideoButton.vue?vue&type=template&id=d4e2c5c2&scoped=true&"
var script = {}
import style0 from "./VideoButton.vue?vue&type=style&index=0&id=d4e2c5c2&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e2c5c2",
  null
  
)

export default component.exports